import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { AppBar, Button, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CustomSVG } from 'components';
import { useContent } from 'hooks';

import { Share } from '../../types';

const useStyles = makeStyles({
  shared: {
    flexGrow: 1,
  },
  footer: {
    top: 'auto',
    bottom: 0,
    boxShadow: '0 -3px 23px 0 rgba(162,162,162,0.47)',
  },
  shareButton: {
    borderRadius: 20,
  },
});

const PartnerShareFooter: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const content = useContent();

  const { isValid, isSubmitting, submitForm, setSubmitting } = useFormikContext<Share>();

  async function handleShare() {
    setSubmitting(true);
    await submitForm();
  }

  return (
    <AppBar component="footer" position="fixed" className={classes.footer}>
      <Toolbar>
        <Typography className={classes.shared}>
          {!!content.share_count && t('content:xHasShared', { count: content.share_count })}
        </Typography>
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={handleShare}
          endIcon={<CustomSVG name="share" />}
          disabled={!isValid || isSubmitting}
          className={classes.shareButton}
        >
          {t('common:share')}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default PartnerShareFooter;
